module.exports = __webpack_public_path__ + "static/media/battery_4.a18ebe7b.png";